// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * EasyZoom core styles
 */
.easyzoom {
  position: relative;
  /* 'Shrink-wrap' the element */
  display: inline-block;
  *display: inline;
  *zoom: 1;
}

.easyzoom img {
  vertical-align: bottom;
}

.easyzoom.is-loading img {
  cursor: progress;
}

.easyzoom.is-ready img {
  cursor: crosshair;
}

.easyzoom.is-error img {
  cursor: not-allowed;
}

.easyzoom-notice {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 150;
  width: 10em;
  margin: -1em 0 0 -5em;
  line-height: 2em;
  text-align: center;
  background: #FFF;
  box-shadow: 0 0 10px #888;
}

.easyzoom-flyout {
  position: absolute;
  z-index: 100;
  overflow: hidden;
  background: #FFF;
}

/**
 * EasyZoom layout variations
 */
.easyzoom--overlay .easyzoom-flyout {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.easyzoom--adjacent .easyzoom-flyout {
  top: 0;
  left: 100%;
  width: 100%;
  height: 100%;
  margin-left: 20px;
}

.easyzoom-flyout img {
  max-width: none;
}`, "",{"version":3,"sources":["webpack://./build/scss/_easyzoom.scss"],"names":[],"mappings":"AAAA;;EAAA;AAGC;EACA,kBAAA;EAEA,8BAAA;EACA,qBAAA;GACA,eAAA;GACA,OAAA;AAAD;;AAGA;EACC,sBAAA;AAAD;;AAGA;EACC,gBAAA;AAAD;;AAGA;EACC,iBAAA;AAAD;;AAGA;EACC,mBAAA;AAAD;;AAGA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAAD;;AAGA;EACC,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAAD;;AAGA;;EAAA;AAGA;EACC,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAAD;;AAGA;EACC,MAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAAD;;AAII;EACI,eAAA;AADR","sourcesContent":["/**\n * EasyZoom core styles\n */\n .easyzoom {\n\tposition: relative;\n\n\t/* 'Shrink-wrap' the element */\n\tdisplay: inline-block;\n\t*display: inline;\n\t*zoom: 1;\n}\n\n.easyzoom img {\n\tvertical-align: bottom;\n}\n\n.easyzoom.is-loading img {\n\tcursor: progress;\n}\n\n.easyzoom.is-ready img {\n\tcursor: crosshair;\n}\n\n.easyzoom.is-error  img {\n\tcursor: not-allowed;\n}\n\n.easyzoom-notice {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\tz-index: 150;\n\twidth: 10em;\n\tmargin: -1em 0 0 -5em;\n\tline-height: 2em;\n\ttext-align: center;\n\tbackground: #FFF;\n\tbox-shadow: 0 0 10px #888;\n}\n\n.easyzoom-flyout {\n\tposition:absolute;\n\tz-index: 100;\n\toverflow: hidden;\n\tbackground: #FFF;\n}\n\n/**\n * EasyZoom layout variations\n */\n.easyzoom--overlay .easyzoom-flyout {\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.easyzoom--adjacent .easyzoom-flyout {\n\ttop: 0;\n\tleft: 100%;\n\twidth: 100%;\n\theight: 100%;\n\tmargin-left: 20px;\n}\n\n.easyzoom-flyout {\n    img {\n        max-width: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
